export default __webpack_public_path__ + "static/media/pousada_1.38c13de1.jpg";